import api from './api';

export interface IEditVacancyParams {
  cityDisplayName?: string,
  city?: string,
  cityOrder?: number,
  experienceDisplayName?: string,
  experience?: string,
  experienceOrder?: number,
  employmentTypeDisplayName?: string,
  employmentType?: string,
  employmentTypeOrder?: number,
  scheduleDisplayName?: string,
  schedule?: string,
  scheduleOrder?: number,
  salaryDisplayName?: string,
  salary?: string,
  salaryOrder?: number,
  workFormatDisplayName?: string,
  workFormat?: string,
  workFormatOrder?: number,
  gradeDisplayName?: string,
  grade?: string,
  gradeOrder?: number,
  titleDisplayName?: string,
  title?: string,
  titleOrder?: number,
  responsibilitiesDisplayName?: string,
  responsibilities?: string,
  responsibilitiesOrder?: number,
  descriptionVacancyDisplayName?: string,
  descriptionVacancy?: string,
  descriptionVacancyOrder?: number,
  termsName?: string,
  terms?: string,
  termsOrder?: number,
  requirementsDisplayName?: string,
  requirements?: string,
  requirementsOrder?: number,
  division?: string,
  vacancyGroup?: string,
  alertText?: string,
  alertTextRecommendation?: string,
  responsibleUser?: string,
  private?: false,
  status?: string,
}

async function editAdminVacancyAPI(id: string, data: IEditVacancyParams) {
  const editFormData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      editFormData.append(key, value);
    }
  });
  const response = await api.patch(`admin_vacancy/${id}}/`, editFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: editFormData,
  });
  return response?.data;
}

export default editAdminVacancyAPI;
